export default "__VITE_ASSET__DkeSXk6Y__"